import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar", "logo", "link", "menuBtn"]

  connect() {
    this.scrolled = false
    this.onScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  handleScroll() {
    const shouldBeScrolled = window.scrollY > 80

    if (shouldBeScrolled === this.scrolled) return
    this.scrolled = shouldBeScrolled

    if (this.scrolled) {
      // Solid white bar
      this.barTarget.classList.remove("bg-black/20", "backdrop-blur-sm")
      this.barTarget.classList.add("bg-white", "shadow-md")
      this.logoTarget.classList.remove("text-white")
      this.logoTarget.classList.add("text-slate-900")
      if (this.hasMenuBtnTarget) {
        this.menuBtnTarget.classList.remove("text-white")
        this.menuBtnTarget.classList.add("text-slate-900")
      }
      this.linkTargets.forEach(link => {
        link.classList.remove("text-white/90")
        link.classList.add("text-slate-700")
      })
    } else {
      // Frosted glass over hero
      this.barTarget.classList.add("bg-black/20", "backdrop-blur-sm")
      this.barTarget.classList.remove("bg-white", "shadow-md")
      this.logoTarget.classList.add("text-white")
      this.logoTarget.classList.remove("text-slate-900")
      if (this.hasMenuBtnTarget) {
        this.menuBtnTarget.classList.add("text-white")
        this.menuBtnTarget.classList.remove("text-slate-900")
      }
      this.linkTargets.forEach(link => {
        link.classList.add("text-white/90")
        link.classList.remove("text-slate-700")
      })
    }
  }
}
